import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

// Numeric count pill (sidebar items, menus). Renders nothing for 0 / empty; caps at "99+".
// tone: brand (default), solid (on an active/selected item), alert (unread notifications).
export default function GrCountBadge({
  count,
  tone = "brand",
  label,
  sx,
  ...rest
}) {
  const n = Number(count);
  if (!Number.isFinite(n) || n <= 0) return null;
  const alert = tone === "alert";
  const solid = tone === "solid";
  return (
    <Box
      component="span"
      aria-label={label || `${n}`}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 20,
        height: 20,
        padding: `0 ${gr.space[1]}`,
        borderRadius: gr.radius.pill,
        background: alert
          ? gr.color.overdue
          : solid
          ? gr.color.brand
          : gr.color.brandSoft,
        color: alert || solid ? gr.color.onBrand : gr.color.brandDark,
        fontFamily: gr.font.family,
        fontSize: gr.font.size.xs,
        fontWeight: gr.font.weight.semibold,
        lineHeight: 1,
        fontVariantNumeric: "tabular-nums",
        flex: "none",
        ...sx,
      }}
      {...rest}
    >
      {n > 99 ? "99+" : n}
    </Box>
  );
}

GrCountBadge.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tone: PropTypes.oneOf(["brand", "solid", "alert"]),
  label: PropTypes.string,
  sx: PropTypes.object,
};
